export default __webpack_public_path__ + "static/media/bottle.205b8c0f.svg";